import React from "react";

import {
  Avatar,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Checkbox,
  Typography,
  Grid,
  IconButton,
} from "@mui/material";
import {
  ChevronRight,
  SensorDoorOutlined,
  WifiOffOutlined,
  WifiOutlined,
} from "@mui/icons-material";
import { makeStyles } from "tss-react/mui";

import { IFilteredListLIProps } from "components/MUIExtensions/FilteredList";
import { SceneSpaceDetail } from "generated/proto/enermatch/automation/v1/scene";
import { useHistory } from "react-router-dom";
import { CREATE_ENVIRONMENT } from "routers/routePaths";

const useStyles = makeStyles()((theme) => ({
  item: {
    border: `1px solid ${theme.palette.secondary.light}`,
    borderRadius: "12px",

    "& ~ &": {
      marginTop: theme.spacing(2),
    },
  },
  avatar: {
    borderRadius: "12px",
    height: theme.spacing(6),
    marginRight: theme.spacing(1),
    width: theme.spacing(6),
  },
  check: {
    color: theme.palette.secondary.light,
  },
}));

export const ListItemSpaces = ({
  item,
  onItemSelect,
}: IFilteredListLIProps<SceneSpaceDetail>) => {
  const { classes } = useStyles();
  const history = useHistory();

  const handleItemUpdate = ({ target: { checked } }) => {
    // @ts-expect-error button that triggers this handler isn't rendered if onItemSelect is null
    onItemSelect(item, checked);
  };

  const handleClick = () => {
    history.push(`${CREATE_ENVIRONMENT}`, { item });
  };

  return (
    <ListItem
      className={classes.item}
      secondaryAction={
        <IconButton onClick={handleClick}>
          <ChevronRight />
        </IconButton>
      }
    >
      <ListItemAvatar>
        <Avatar
          className={classes.avatar}
          sx={{
            bgcolor:
              item.offlineDevices || !item.onlineDevices
                ? "secondary.light"
                : "success.light",
          }}
          variant="square"
        >
          <SensorDoorOutlined color="secondary" />
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={item.name}
        secondary={
          <Grid container direction="row" alignItems="center">
            {item.onlineDevices > 0 && (
              <Grid item alignItems="center" sx={{ display: "flex" }}>
                <WifiOutlined color="primary" sx={{ mr: 1 }} />
                <Typography component="span" sx={{ mr: 2 }}>
                  {item.onlineDevices}
                </Typography>
              </Grid>
            )}
            {item.offlineDevices > 0 && (
              <Grid item alignItems="center" sx={{ display: "flex" }}>
                <WifiOffOutlined color="secondary" sx={{ mr: 1 }} />
                <Typography component="span">{item.offlineDevices}</Typography>
              </Grid>
            )}
          </Grid>
        }
      />
      {!!onItemSelect &&
        (item.isMember || (!item.offlineDevices && item.onlineDevices)) && (
          <Checkbox
            className={classes.check}
            checked={item.isMember}
            onChange={handleItemUpdate}
            disabled={!!(item.offlineDevices || !item.onlineDevices)}
          />
        )}
    </ListItem>
  );
};
